import { Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from 'react';
import * as Formik from 'formik';
import * as Common from '_common';
import * as Components from '_components';
import * as Utils from '_utils';
import { useNavigate } from 'react-router';
export function userComponentRegister(type) {
    switch (type) {
        case 'name':
            return UserName;
        case 'login':
            return UserLogin;
        case 'rolelist':
            return UserRoleList;
        case 'languagebuttons':
            return UserLanguageButtons;
        case 'themebuttons':
            return UserThemeButtons;
        case 'loginform':
            return LoginForm;
        case 'logoutbutton':
            return LogoutButton;
    }
}
export function UserName() {
    const user = Common.useUser();
    return _jsx(_Fragment, { children: user.name });
}
export function UserLogin() {
    const user = Common.useUser();
    return _jsx(_Fragment, { children: user.login });
}
export function UserRoleList() {
    function getSource(role) {
        if (role && user.roleSources) {
            return user.roleSources[role];
        }
    }
    function formatRoleInfo(role, source) {
        const isPrimary = source === 'primary';
        const styles = Utils.classNames({
            ['gray']: !isPrimary,
        });
        let sourceInfo;
        if (source === 'public') {
            sourceInfo = (_jsx(Components.MLT, { en: "This role is automatically assigned to all users." }));
        }
        else if (source === 'auth') {
            sourceInfo = (_jsx(Components.MLT, { en: "This role is automatically assigned to authenticated users." }));
        }
        else if (source === 'primary' || !source) {
            sourceInfo = '';
        }
        else {
            sourceInfo = (_jsx(Components.MLT, { en: `This role is automatically assigned base on rule with name ${source}.` }));
        }
        return (_jsxs("li", { className: styles, children: [role, " ", _jsx("small", { children: sourceInfo })] }, role));
    }
    const user = Common.useUser();
    return _jsx(_Fragment, { children: user.roles.sort().map(i => formatRoleInfo(i, getSource(i))) });
}
export function UserLanguageButtons() {
    const languageContext = React.useContext(Common.LanguageContext);
    return (_jsxs(Components.BtnGroup, { children: [_jsx(Components.Button, { isActive: languageContext.language === 'en', onClick: () => languageContext.setLanguage('en'), children: "English" }), _jsx(Components.Button, { isActive: languageContext.language === 'cs', onClick: () => languageContext.setLanguage('cs'), children: "\u010Cesky" })] }));
}
export function UserThemeButtons() {
    const theme = Common.useTheme();
    // TODO set isActive on selected button
    return (_jsxs(Components.BtnGroup, { children: [_jsx(Components.Button, { isDisabled: true, onClick: () => theme.setTheme({
                    name: Common.ThemeDefault,
                    variant: Common.ThemeLight,
                }), children: "Light" }), _jsx(Components.Button, { isDisabled: true, onClick: () => theme.setTheme({
                    name: Common.ThemeDefault,
                    variant: Common.ThemeDark,
                }), children: "Dark" }), _jsx(Components.Button, { onClick: () => theme.setTheme({
                    name: Common.ThemeLcars,
                    variant: Common.ThemeDark,
                }), children: "Lcars" })] }));
}
export function LoginForm() {
    const lang = Common.useLanguage();
    const userCtx = Common.useUser();
    const settingsDialog = Common.useSettingsDialog();
    const navigate = useNavigate();
    const validate = (values) => {
        const errors = {};
        if (!values.login) {
            errors.login = Common.LocalText({
                en: 'Login is required.',
                cs: 'Uživatelské jméno je povinné.',
            }, lang);
        }
        if (!values.password) {
            errors.password = Common.LocalText({ en: 'Password is required.', cs: 'Heslo je povinné.' }, lang);
        }
        return errors;
    };
    const onSubmit = async (values, { setSubmitting, setErrors }) => {
        setSubmitting(true);
        try {
            const user = await Common.TryLogin(values);
            userCtx.setUser(user);
            settingsDialog.setTab(Common.SettingsTabs.None);
            navigate('/');
        }
        catch (e) {
            setErrors({
                login: Common.LocalText({
                    en: 'Login or password is not correct.',
                    cs: 'Jméno nebo heslo nejsou správné.',
                }, lang),
            });
        }
        setSubmitting(false);
    };
    return (_jsx(Formik.Formik, { initialValues: {
            login: '',
            password: '',
        }, validate: validate, onSubmit: onSubmit, children: ({ values, errors, touched, handleChange, handleBlur, handleSubmit, isSubmitting, }) => (_jsxs("form", { onSubmit: handleSubmit, children: [_jsx(Components.TextInput, { label: { cs: 'Jméno', en: 'Login' }, name: "login", value: values.login, onChange: handleChange, onBlur: handleBlur, isValid: touched.login && !errors.login, isInvalid: !!errors.login, autoComplete: "username", validationMessage: touched.login ? errors.login : undefined }), _jsx(Components.PasswordInput, { label: { cs: 'Heslo', en: 'Password' }, name: "password", value: values.password, onChange: handleChange, onBlur: handleBlur, isValid: touched.password && !errors.password, isInvalid: !!errors.password, autoComplete: "current-password", validationMessage: touched.password ? errors.password : undefined }), _jsx(Components.SubmitButton, { children: "Ok" })] })) }));
}
export function LogoutButton() {
    const state = Common.useUser();
    const dialog = Common.useSettingsDialog();
    const navigate = useNavigate();
    async function logout() {
        const user = await Common.Logout();
        state.setUser(user);
        dialog.setTab(Common.SettingsTabs.None);
        sessionStorage.clear();
        navigate('/');
    }
    return (_jsx(Components.Button, { onClick: logout, children: _jsx(Components.MLT, { cs: "Odhl\u00E1sit se", en: "Logout" }) }));
}
